// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"56":"Showcase","176":"Usage","466":"Demo"}[chunkId] + "." + {"56":"bf83ce70","176":"6689098f","466":"e58343de"}[chunkId] + ".css";
};